/**
 * @param {unknown} value
 */
function normalizeMuxId(value) {
    return typeof value === "string" ? value.trim() : "";
}

/**
 * @param {{ data?: { showcaseThumbnailMuxId?: unknown, muxId?: unknown } } | null | undefined} post
 */
export function getShowcaseThumbnailMuxId(post) {
    const showcaseThumbnailMuxId = normalizeMuxId(post?.data?.showcaseThumbnailMuxId);

    if (showcaseThumbnailMuxId.length > 0) {
        return showcaseThumbnailMuxId;
    }

    return normalizeMuxId(post?.data?.muxId);
}
